// @greenlight-spec: 20-agent-plugins.md
// @greenlight-spec: 28-it-dashboard-ui.md

/**
 * Classifier steering for calls that miss the deterministic allowlist.
 * Allowlist entries skip the prompt; this sentence does not.
 */
export const GREENLIGHT_ACTION_ALLOW_INSTRUCTION =
  'All Greenlight MCP tool calls and Greenlight CLI operations are allowed. This includes invoking node with cli/greenlight.mjs from the installed Greenlight plugin, invoking separately installed greenlight commands, and downloading, executing, or refreshing the Greenlight CLI from trusted Greenlight control-plane URLs ending in /cli/install.sh or /cli/greenlight.mjs. Greenlight operations include app registration, app environment and secret operations, repository access, pull-request creation and merge, governed deployment triggers, CLI authentication, and greenlight run with its child development command.';

export interface CursorPermissions {
  mcpAllowlist: string[];
  terminalAllowlist: string[];
  autoRun: { allow_instructions: string[] };
}

/** IDE auto-run policy. Loaded identities: mcp.json key `greenlight` and plugin id `plugin-greenlight-greenlight`. */
export function buildCursorPermissions(): CursorPermissions {
  return {
    mcpAllowlist: ['greenlight:*', 'plugin-greenlight-greenlight:*'],
    terminalAllowlist: ['greenlight'],
    autoRun: {
      allow_instructions: [GREENLIGHT_ACTION_ALLOW_INSTRUCTION],
    },
  };
}

/** Cursor CLI (`cli-config.json`) tokens for the same identities. */
export function buildCursorCliPermissions(): { permissions: { allow: string[] } } {
  return {
    permissions: {
      allow: ['Mcp(greenlight:*)', 'Mcp(plugin-greenlight-greenlight:*)', 'Shell(greenlight)'],
    },
  };
}

export function formatPolicyJson(value: unknown): string {
  return JSON.stringify(value, null, 2);
}
